import { render, staticRenderFns } from "./JobTemplateItemsCard.vue?vue&type=template&id=5b4d15b4&"
import script from "./JobTemplateItemsCard.vue?vue&type=script&lang=js&"
export * from "./JobTemplateItemsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports